<template>
  <div class="rules-wrapper">
    <div class="rules-box">
      <div class="logo">
        <img :src="logoLink" alt="" class="logo" />
      </div>
      <h1 class="title_welcome">{{ $t('freebet.rules.title', { prize: currentPrize }) }}</h1>
      <p class="from_to_data_welcome" style="text-align: center">
        {{ getFreeBetStartData }} — {{ getFreeBetFinishData }}
      </p>
      <h2 class="price_fond_welcome">
        {{
          $t('freebet.rules.game_title', {
            game,
            prize: currentPrize
          })
        }}
      </h2>
      <ul class="info_list_welcome">
        <li class="info_item_welcome">
          {{
            $t('freebet.rules.condition_min_bet', {
              currencyCode: getFormatedCurrency,
              minBet: getFreeBetMinBet,
              prize: currentPrize
            })
          }}
        </li>
        <li v-if="isFreeBetRoundsCondition" class="info_item_welcome">
          {{
            $t('freebet.rules.condition_rounds', {
              rounds: getTotalFreeBetProgress,
              games: game,
              prize: currentPrize
            })
          }}
        </li>
        <li v-if="isFreeBetBetsCondition" class="info_item_welcome">
          {{
            $t('freebet.rules.condition_bets', {
              bets: getTotalFreeBetProgress,
              games: game,
              currencyCode: getFormatedCurrency,
              prize: currentPrize
            })
          }}
        </li>
        <li class="info_item_welcome">
          {{
            $t('freebet.rules.prize', {
              game,
              prize: currentPrize
            })
          }}
        </li>
        <li class="info_item_welcome">
          {{
            $t('freebet.rules.free_bet_spins_amount', {
              freeBetSpinsAmount: getMaxFreeBetsForDay,
              prize: currentPrize
            })
          }}
        </li>
        <li class="info_item_welcome">
          {{
            $t('freebet.rules.max_bets', {
              maxFreeBetSpins: getMaxFreeBetsForPlayer
            })
          }}
        </li>
      </ul>
    </div>
    <div class="popup_button_ok custom_close_btn" @click="onCloseClick">
      <defaultButton :text="btnCloseText" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import defaultButton from '@/components/otherComponents/DefaultButton.vue';
import { ACTION } from '@/store/ACTION';
import { Utils } from '@/utils/Utils';

export default Vue.extend({
  name: 'WelcomeRules',
  components: {
    defaultButton
  },
  computed: {
    ...mapGetters([
      'hasFreeBet',
      'getFreeBetStartData',
      'getFreeBetFinishData',
      'getFreeBetMinBet',
      'getFreeBetCurrencyCode',
      'isFreeBetRoundsCondition',
      'isFreeBetBetsCondition',
      'getTotalFreeBetProgress',
      'getMaxFreeBetsForPlayer',
      'getMaxFreeBetsForDay'
    ]),
    getFormatedCurrency(): string {
      return Utils.formatCurrencyCodeToMili(this.getFreeBetCurrencyCode);
    },
    btnCloseText(): string {
      return <string>this.$i18n.t('welcome_popup.play') || '';
    },
    logoLink(): string {
      return `${__PROMO_CONFIG.STATIC_URL}/assets/img/logo_gamzix.png`;
    },
    currentPrize(): string {
      return this.hasFreeBet ? <string>this.$i18n.t('freebet.title') : '';
    },
    game(): string {
      return 'Pilot';
    }
  },
  methods: {
    onCloseClick(): void {
      promoApp.eventEmitter.emit(ACTION.SET_TAB_WELCOME_VISIBLE, { visible: false });
    }
  }
});
</script>

<style lang="scss" scoped>
.rules-box {
  height: 100%;
  max-height: 87%;
  overflow: auto;
}

.logo {
  display: flex;
  justify-content: center;

  img {
    width: 280px;
  }
}

.title_welcome {
  text-align: center;
  font-size: 3em;
  font-weight: bold;
  color: #f9b733;
}

.from_to_data_welcome {
  font-family: 'myriadpro-cond', sans-serif;
  font-size: 1.3em;
  text-align: center;
}

.price_fond_welcome {
  font-family: 'myriadpro-boldcond', sans-serif;
  color: #f9b733;
  text-align: center;
  font-size: 2em;
  font-weight: bold;
}
</style>
